export default {
      id: "download-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite.svg#download-usage",
      toString: function () {
        return this.url;
      }
    }